import { jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraLink, SpecraText } from '@mono/ui-components/ensigns';
import { SpecraPopover } from '@mono/ui-components/lieutenants';
import { pricingHref } from './pricingRoutes';
export function HoursPopover({ scope, row, anchor, onClose }) {
    return /*#__PURE__*/ _jsxs(SpecraPopover, {
        open: true,
        anchor: anchor,
        onOpenChange: (v)=>{
            if (!v) onClose();
        },
        "aria-label": "Hours from CLINs",
        children: [
            /*#__PURE__*/ _jsxs(SpecraText, {
                as: "p",
                children: [
                    row.hours || '—',
                    " hours · ",
                    scope.period
                ]
            }),
            row.hoursClinNumbers.map((n)=>/*#__PURE__*/ _jsxs(SpecraLink, {
                    className: "block",
                    href: pricingHref(scope.projectId, scope.scenarioId, `clin/${n}`, {
                        period: scope.period
                    }),
                    children: [
                        "CLIN ",
                        n
                    ]
                }, n))
        ]
    });
}
